import classNames from "classnames";
import Link from "next/link";
import { ReactNode } from "react";

interface PropsBreadcrumbItemProps {
  href?: string;
  withoutLink?: boolean;
  label?: string;
  className?: string;
  children?: ReactNode;
}

const BreadcrumbItem: React.FC<PropsBreadcrumbItemProps> = ({
  children,
  href,
  withoutLink,
  label,
  className,
  ...props
}) => {
  return (
    <li {...props}>
      {href && !withoutLink ? (
        <Link
          href={href}
          aria-label={label}
          className={classNames(
            "text-[#71717A] leading-[18px] block font-normal text-xs",
            className || "",
          )}
        >
          {children}
        </Link>
      ) : (
        <span
          className={classNames(
            "text-[#3F3F46] font-normal text-xs block leading-[18px]",
            className || "",
          )}
        >
          {children}
        </span>
      )}
    </li>
  );
};

export default BreadcrumbItem;
